<template>
  <b-modal
    id="submitModal"
    body-class="py-0 px-4 text-secondary"
    centered
    footerClass="p-3 border-top-0"
    headerClass="pt-3 pb-2 mt-2 border-bottom-0 text-center"
    no-close-on-backdrop
    no-close-on-esc
    @cancel="cancelSubmit()"
    @hide="cancelSubmit()"
    @ok="modalOk()"
    ><p class="text-center">Please fill in the request details</p>
    <b-form-input
      ref="email"
      v-model="email"
      class="mt-4 rounded-pill"
      readonly
      type="email"
    ></b-form-input>
    <!-- <validation-observer ref="observer">
      <validation-provider
        ref="provider"
        v-slot="validationContext"
        :rules="{ required: true, regex: /^(\+)?([0-9]+)$/ }"
      >
        <b-form-input
          ref="phone"
          v-model="number"
          :state="getValidationState(validationContext)"
          class="mt-4 rounded-pill"
          placeholder="Phone Number (with international code)"
          type="tel"
          @input="onFormUpdate"
        ></b-form-input>
        <b-form-invalid-feedback id="validationFeedback"
          >{{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </validation-provider>
    </validation-observer> -->

    <template #modal-header="{}">
      <div class="modal-header-text font-weight-bold pb-0 mb-0 pl-1 w-100">Submit request</div>
    </template>
    <template #modal-footer="{ ok, cancel }">
      <b-button :disabled="disableSubmit" pill variant="primary" @click="ok()">
        Submit Request
      </b-button>
      <b-button pill variant="link" @click="cancel()">Cancel</b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: {
      phoneNumber: String,
      email: String,
    },
    data() {
      return {
        disableSubmit: true,
        number: '',
      };
    },
    mounted() {
      this.$root.$on('bv::modal::shown', () => {
        this.number = this.phoneNumber;
        if (this.number !== '') {
          this.disableSubmit = false;
        }
      });
    },
    methods: {
      async onFormUpdate() {
        const isValid = await this.$refs.observer.validate();
        this.disableSubmit = !isValid;
      },
      getValidationState({ dirty, validated, valid = null, required }) {
        if (required) {
          return dirty || validated ? valid : null;
        }
      },
      cancelSubmit() {
        // this.number = this.phoneNumber;
        // this.$emit('update:phoneNumber', this.number);
        this.disableSubmit = true;
        this.$bvModal.hide('submitModal');
      },
      modalOk() {
        // this.$emit('update:phoneNumber', this.number);
        this.$emit('proceedToSubmit');
      },
    },
  };
</script>

<style></style>
